import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

const API = 'https://groovie-business-api-production.up.railway.app/api/v1';

const EVENT_TYPES = [
  { value: 'birthday', label: 'Birthday', bg: '#fce7f3', color: '#be185d', border: '#f9a8d4' },
  { value: 'anniversary', label: 'Anniversary', bg: '#fef3c7', color: '#b45309', border: '#fcd34d' },
  { value: 'promotion', label: 'Promotion', bg: '#dcfce7', color: '#15803d', border: '#86efac' },
  { value: 'holiday', label: 'Holiday', bg: '#dbeafe', color: '#1d4ed8', border: '#93c5fd' },
  { value: 'special', label: 'Special', bg: '#f3e8ff', color: '#7c3aed', border: '#c4b5fd' },
  { value: 'meeting', label: 'Meeting', bg: '#f3f4f6', color: '#374151', border: '#d1d5db' },
  { value: 'training', label: 'Training', bg: '#cffafe', color: '#0e7490', border: '#67e8f9' },
  { value: 'general', label: 'General', bg: '#f1f5f9', color: '#475569', border: '#cbd5e1' },
];

const FREQUENCIES = [
  { value: 'none', label: 'One-time' }, { value: 'daily', label: 'Daily' },
  { value: 'weekly', label: 'Weekly' }, { value: 'monthly', label: 'Monthly' },
  { value: 'yearly', label: 'Yearly' },
];

const PRIORITIES = [
  { value: 'low', label: 'Low', color: '#3b82f6' },
  { value: 'normal', label: 'Normal', color: '#22c55e' },
  { value: 'high', label: 'High', color: '#f59e0b' },
  { value: 'urgent', label: 'Urgent', color: '#ef4444' },
];

const DEFAULT_FORM = {
  title: '', description: '', event_type: 'general',
  start_datetime: '', end_datetime: '', all_day: false,
  location_id: null, channel_id: null,
  frequency: 'none', dj_announce: false, dj_announcement_text: '',
  play_song: false, song_request: '', special_playlist: '',
  person_name: '', person_role: '', priority: 'normal'
};

const Svg = ({ type, size = 16 }) => {
  const icons = {
    plus: <><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></>,
    edit: <><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/></>,
    trash: <><polyline points="3,6 5,6 21,6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></>,
    upload: <><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17,8 12,3 7,8"/><line x1="12" y1="3" x2="12" y2="15"/></>,
    download: <><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7,10 12,15 17,10"/><line x1="12" y1="15" x2="12" y2="3"/></>,
    calendar: <><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></>,
    list: <><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></>,
    chevL: <><polyline points="15,18 9,12 15,6"/></>,
    chevR: <><polyline points="9,18 15,12 9,6"/></>,
    mic: <><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/></>,
    music: <><path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/></>,
    user: <><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></>,
    clock: <><circle cx="12" cy="12" r="10"/><polyline points="12,6 12,12 16,14"/></>,
    repeat: <><polyline points="17,1 21,5 17,9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7,23 3,19 7,15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></>,
    check: <><polyline points="20,6 9,17 4,12"/></>,
  };
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{icons[type]}</svg>
  );
};

const inputStyle = {
  width: '100%', border: '1.5px solid #e5e7eb', borderRadius: 10,
  padding: '11px 14px', fontSize: 14, outline: 'none',
  fontFamily: "'Outfit', sans-serif", boxSizing: 'border-box',
  transition: 'border-color 0.15s',
};
const focusIn = (e) => e.target.style.borderColor = '#7c3aed';
const focusOut = (e) => e.target.style.borderColor = '#e5e7eb';

export default function Calendar() {
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const [editing, setEditing] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({ ...DEFAULT_FORM });
  const [saving, setSaving] = useState(false);
  const [filterType, setFilterType] = useState('all');
  const [viewMode, setViewMode] = useState('calendar');
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [uploadData, setUploadData] = useState(null);
  const [uploadResults, setUploadResults] = useState(null);
  const [uploading, setUploading] = useState(false);
  const token = localStorage.getItem('token');
  const headers = { 'Authorization': `Bearer ${token}` };
  const jsonHeaders = { ...headers, 'Content-Type': 'application/json' };

  useEffect(() => { if (!token) { navigate('/login'); return; } fetchEvents(); }, [token, navigate]);

  const fetchEvents = async () => {
    try { setLoading(true); const res = await fetch(`${API}/calendar`, { headers }); if (res.status === 401) { navigate('/login'); return; } if (res.ok) { const d = await res.json(); setEvents(d.events || []); } } catch { setEvents([]); } finally { setLoading(false); }
  };

  const handleSave = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      const url = editing ? `${API}/calendar/${editingId}` : `${API}/calendar`;
      const body = { ...formData };
      if (!body.end_datetime) body.end_datetime = body.start_datetime;
      if (!body.location_id) delete body.location_id;
      if (!body.channel_id) delete body.channel_id;
      const res = await fetch(url, { method: editing ? 'PUT' : 'POST', headers: jsonHeaders, body: JSON.stringify(body) });
      if (!res.ok) { const err = await res.json().catch(() => ({})); throw new Error(err.detail || 'Failed'); }
      await fetchEvents(); closeModal();
    } catch (err) { alert('Failed: ' + err.message); }
    finally { setSaving(false); }
  };

  const handleDelete = async (id, title) => {
    if (!window.confirm(`Delete "${title}"?`)) return;
    try { const res = await fetch(`${API}/calendar/${id}`, { method: 'DELETE', headers }); if (res.ok) await fetchEvents(); } catch { alert('Failed'); }
  };

  const openEdit = (evt) => {
    setFormData({
      title: evt.title || '', description: evt.description || '', event_type: evt.event_type || 'general',
      start_datetime: evt.start_datetime ? evt.start_datetime.slice(0, 16) : '', end_datetime: evt.end_datetime ? evt.end_datetime.slice(0, 16) : '',
      all_day: evt.all_day || false, location_id: evt.location_id || null, channel_id: evt.channel_id || null,
      frequency: evt.frequency || 'none', dj_announce: evt.dj_announce || false, dj_announcement_text: evt.dj_announcement_text || '',
      play_song: evt.play_song || false, song_request: evt.song_request || '', special_playlist: evt.special_playlist || '',
      person_name: evt.person_name || '', person_role: evt.person_role || '', priority: evt.priority || 'normal'
    });
    setEditing(true); setEditingId(evt.id); setShowModal(true);
  };

  const openCreate = (date = null) => {
    const d = date || new Date();
    const iso = new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
    setFormData({ ...DEFAULT_FORM, start_datetime: iso }); setEditing(false); setEditingId(null); setShowModal(true);
  };

  const closeModal = () => { setShowModal(false); setEditing(false); setEditingId(null); setFormData({ ...DEFAULT_FORM }); };

  const handleFileUpload = (e) => {
    const file = e.target.files[0]; if (!file) return;
    const reader = new FileReader();
    reader.onload = (evt) => {
      const lines = evt.target.result.split('\n').map(l => l.trim()).filter(Boolean);
      if (lines.length < 2) { alert('File must have headers and at least one row.'); return; }
      const hdrs = lines[0].split(',').map(h => h.trim().toLowerCase().replace(/\s+/g, '_'));
      const rows = [];
      for (let i = 1; i < lines.length; i++) {
        const vals = parseCSVLine(lines[i]); const obj = {};
        hdrs.forEach((h, idx) => {
          let v = (vals[idx] || '').trim();
          if (['all_day', 'dj_announce', 'play_song'].includes(h)) v = v.toLowerCase() === 'true' || v === '1' || v === 'yes';
          if (['location_id', 'channel_id'].includes(h)) v = v ? parseInt(v) : null;
          obj[h] = v;
        });
        if (obj.name && !obj.person_name) obj.person_name = obj.name;
        if (obj.date && !obj.start_datetime) obj.start_datetime = obj.date.includes('T') ? obj.date : obj.date + 'T09:00:00';
        if (obj.type && !obj.event_type) obj.event_type = obj.type;
        if (!obj.event_type) obj.event_type = 'general';
        if (obj.title && obj.start_datetime) rows.push(obj);
      }
      setUploadData(rows); setUploadResults(null);
    };
    reader.readAsText(file);
  };

  const parseCSVLine = (line) => {
    const r = []; let cur = '', inQ = false;
    for (const c of line) { if (c === '"') { inQ = !inQ; continue; } if (c === ',' && !inQ) { r.push(cur); cur = ''; continue; } cur += c; }
    r.push(cur); return r;
  };

  const handleBulkUpload = async () => {
    if (!uploadData?.length) return; setUploading(true);
    try {
      const res = await fetch(`${API}/calendar/upload`, { method: 'POST', headers: jsonHeaders, body: JSON.stringify(uploadData) });
      if (!res.ok) throw new Error('Upload failed');
      setUploadResults(await res.json()); await fetchEvents();
    } catch (err) { alert('Failed: ' + err.message); }
    finally { setUploading(false); }
  };

  const downloadTemplate = (type) => {
    const templates = {
      birthday: 'title,start_datetime,person_name,person_role,song_request\n"John Smith Birthday","2026-06-15T09:00:00","John Smith","employee","Happy by Pharrell Williams"',
      anniversary: 'title,start_datetime,person_name,person_role,description\n"Jane Doe 5-Year Anniversary","2026-04-20T10:00:00","Jane Doe","manager","5 years of great work"',
      promotion: 'title,start_datetime,end_datetime,description,priority\n"Summer Sale","2026-06-01T00:00:00","2026-06-30T23:59:00","50% off all summer items!","high"',
      holiday: 'title,start_datetime,description,special_playlist\n"Independence Day","2026-07-04T00:00:00","Office closed","patriotic"',
      mixed: 'title,event_type,start_datetime,end_datetime,person_name,person_role,description,song_request,priority\n"John Birthday","birthday","2026-06-15T09:00:00","","John Smith","employee","","Happy by Pharrell","normal"'
    };
    const blob = new Blob([templates[type] || templates.mixed], { type: 'text/csv' });
    const url = URL.createObjectURL(blob); const a = document.createElement('a');
    a.href = url; a.download = `groovie_calendar_${type}_template.csv`; a.click(); URL.revokeObjectURL(url);
  };

  const getTypeInfo = (type) => EVENT_TYPES.find(t => t.value === type) || EVENT_TYPES[7];
  const formatDate = (iso) => iso ? new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '';
  const formatTime = (iso) => iso ? new Date(iso).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }) : '';
  const isPersonEvent = (t) => ['birthday', 'anniversary'].includes(t);
  const isDJEvent = (t) => ['birthday', 'anniversary', 'promotion', 'special'].includes(t);

  const calendarData = useMemo(() => {
    const y = currentMonth.getFullYear(), m = currentMonth.getMonth();
    const first = new Date(y, m, 1), last = new Date(y, m + 1, 0);
    const pad = first.getDay(), days = [];
    for (let i = pad - 1; i >= 0; i--) days.push({ date: new Date(y, m, -i), inMonth: false, events: [] });
    for (let d = 1; d <= last.getDate(); d++) days.push({ date: new Date(y, m, d), inMonth: true, events: [] });
    while (days.length % 7 !== 0) days.push({ date: new Date(y, m + 1, days.length - pad - last.getDate() + 1), inMonth: false, events: [] });
    const fil = filterType === 'all' ? events : events.filter(e => e.event_type === filterType);
    fil.forEach(evt => { const ed = new Date(evt.start_datetime); days.forEach(d => { if (d.date.toDateString() === ed.toDateString()) d.events.push(evt); }); });
    return days;
  }, [events, currentMonth, filterType]);

  const filteredEvents = useMemo(() => {
    let list = [...events];
    if (filterType !== 'all') list = list.filter(e => e.event_type === filterType);
    return list.sort((a, b) => new Date(a.start_datetime) - new Date(b.start_datetime));
  }, [events, filterType]);

  const isToday = (d) => d.toDateString() === new Date().toDateString();
  const upcomingCount = events.filter(e => new Date(e.start_datetime) >= new Date()).length;
  const djCount = events.filter(e => e.dj_announce).length;

  const pillBtn = (selected, info, onClick) => (
    <button type="button" onClick={onClick} style={{
      padding: '6px 14px', borderRadius: 8, fontSize: 11, fontWeight: 600,
      border: selected ? `2px solid ${info.border}` : '1.5px solid #e5e7eb',
      background: selected ? info.bg : '#fff', color: selected ? info.color : '#6b7280',
      cursor: 'pointer', transition: 'all 0.15s',
    }}>{info.label}</button>
  );

  const modalWrap = (children) => (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, padding: 16, backdropFilter: 'blur(4px)' }}>
      <div style={{ background: '#fff', borderRadius: 20, width: '100%', maxWidth: 560, maxHeight: '90vh', overflowY: 'auto', padding: 32, boxShadow: '0 25px 60px rgba(0,0,0,0.15)' }}>
        {children}
      </div>
    </div>
  );

  if (loading) return (
    <div style={{ padding: 40, display: 'flex', justifyContent: 'center' }}>
      <div style={{ width: 48, height: 48, borderRadius: '50%', border: '3px solid #e9d5ff', borderTopColor: '#7c3aed', animation: 'spin 0.8s linear infinite' }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );

  return (
    <div style={{ padding: '32px 40px', maxWidth: 1200, margin: '0 auto', fontFamily: "'Outfit', 'DM Sans', sans-serif" }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 28 }}>
        <div>
          <h1 style={{ fontSize: 26, fontWeight: 700, color: '#111827', margin: 0, letterSpacing: '-0.5px' }}>Calendar</h1>
          <p style={{ fontSize: 14, color: '#9ca3af', marginTop: 4 }}>{events.length} events &middot; {upcomingCount} upcoming &middot; {djCount} with DJ announce</p>
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={() => setShowUpload(true)} style={{
            display: 'flex', alignItems: 'center', gap: 8,
            padding: '12px 22px', borderRadius: 12, fontSize: 14, fontWeight: 600,
            border: 'none', cursor: 'pointer',
            background: 'linear-gradient(135deg, #2563eb, #3b82f6)', color: '#fff',
            fontFamily: "'Outfit', sans-serif", boxShadow: '0 4px 12px rgba(37,99,235,0.3)',
          }}><Svg type="upload" size={16} /> Upload CSV</button>
          <button onClick={() => openCreate()} style={{
            display: 'flex', alignItems: 'center', gap: 8,
            background: 'linear-gradient(135deg, #7c3aed, #a855f7)', color: '#fff',
            border: 'none', borderRadius: 12, padding: '12px 24px', fontSize: 14, fontWeight: 600,
            cursor: 'pointer', fontFamily: "'Outfit', sans-serif",
            boxShadow: '0 4px 12px rgba(124,58,237,0.3)',
          }}><Svg type="plus" size={16} /> New Event</button>
        </div>
      </div>

      {/* View toggle + filters */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 24, flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', background: '#f3f4f6', borderRadius: 10, padding: 3 }}>
          {[{ key: 'calendar', icon: 'calendar', label: 'Calendar' }, { key: 'list', icon: 'list', label: 'List' }].map(v => (
            <button key={v.key} onClick={() => setViewMode(v.key)} style={{
              display: 'flex', alignItems: 'center', gap: 6, padding: '8px 18px', borderRadius: 8,
              fontSize: 13, fontWeight: 600, border: 'none', cursor: 'pointer',
              background: viewMode === v.key ? '#fff' : 'transparent',
              color: viewMode === v.key ? '#7c3aed' : '#6b7280',
              boxShadow: viewMode === v.key ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
            }}><Svg type={v.icon} size={14} /> {v.label}</button>
          ))}
        </div>
        <select value={filterType} onChange={(e) => setFilterType(e.target.value)} style={{ ...inputStyle, width: 'auto', minWidth: 160 }}>
          <option value="all">All Types</option>
          {EVENT_TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
        </select>
        <div style={{ display: 'flex', gap: 6, marginLeft: 'auto', flexWrap: 'wrap' }}>
          {EVENT_TYPES.slice(0, 5).map(t => (
            <span key={t.value} style={{ padding: '2px 8px', borderRadius: 6, fontSize: 10, fontWeight: 600, background: t.bg, color: t.color }}>{t.label}</span>
          ))}
        </div>
      </div>

      {/* CALENDAR VIEW */}
      {viewMode === 'calendar' && (
        <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #e5e7eb', overflow: 'hidden' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 24px', borderBottom: '1px solid #e5e7eb' }}>
            <button onClick={() => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1))} style={{ padding: 8, borderRadius: 8, border: 'none', cursor: 'pointer', background: 'transparent', color: '#6b7280' }}
              onMouseEnter={(e) => e.currentTarget.style.background = '#f3f4f6'} onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
            ><Svg type="chevL" size={18} /></button>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <h2 style={{ fontSize: 18, fontWeight: 700, color: '#111827', margin: 0 }}>
                {currentMonth.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}
              </h2>
              <button onClick={() => setCurrentMonth(new Date())} style={{ fontSize: 12, color: '#7c3aed', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 600 }}>Today</button>
            </div>
            <button onClick={() => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1))} style={{ padding: 8, borderRadius: 8, border: 'none', cursor: 'pointer', background: 'transparent', color: '#6b7280' }}
              onMouseEnter={(e) => e.currentTarget.style.background = '#f3f4f6'} onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
            ><Svg type="chevR" size={18} /></button>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', borderBottom: '1px solid #e5e7eb' }}>
            {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(d => (
              <div key={d} style={{ padding: '8px 0', textAlign: 'center', fontSize: 11, fontWeight: 600, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{d}</div>
            ))}
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)' }}>
            {calendarData.map((day, idx) => (
              <div key={idx} onClick={() => day.inMonth && openCreate(day.date)}
                style={{
                  minHeight: 100, borderBottom: '1px solid #f3f4f6', borderRight: '1px solid #f3f4f6',
                  padding: 6, cursor: 'pointer', transition: 'background 0.1s',
                  background: isToday(day.date) ? '#f5f3ff' : !day.inMonth ? '#fafafa' : '#fff',
                  outline: isToday(day.date) ? '1px solid #c4b5fd' : 'none', outlineOffset: -1,
                }}
                onMouseEnter={(e) => { if (!isToday(day.date)) e.currentTarget.style.background = '#faf5ff'; }}
                onMouseLeave={(e) => { if (!isToday(day.date)) e.currentTarget.style.background = !day.inMonth ? '#fafafa' : '#fff'; }}
              >
                <div style={{ fontSize: 12, fontWeight: isToday(day.date) ? 700 : 500, color: isToday(day.date) ? '#7c3aed' : day.inMonth ? '#374151' : '#d1d5db', marginBottom: 4 }}>
                  {day.date.getDate()}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  {day.events.slice(0, 3).map(evt => {
                    const info = getTypeInfo(evt.event_type);
                    return (
                      <div key={evt.id} onClick={(e) => { e.stopPropagation(); openEdit(evt); }}
                        style={{
                          fontSize: 10, lineHeight: '14px', padding: '2px 6px', borderRadius: 4,
                          background: info.bg, color: info.color, border: `1px solid ${info.border}`,
                          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', cursor: 'pointer',
                        }} title={evt.title}>
                        {evt.dj_announce && '\u{1F3A4} '}{evt.title}
                      </div>
                    );
                  })}
                  {day.events.length > 3 && <div style={{ fontSize: 10, color: '#9ca3af', padding: '0 4px' }}>+{day.events.length - 3} more</div>}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* LIST VIEW */}
      {viewMode === 'list' && (
        filteredEvents.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '64px 24px', background: '#fff', borderRadius: 16, border: '1px solid #e5e7eb' }}>
            <div style={{ color: '#9ca3af', marginBottom: 16 }}><Svg type="calendar" size={48} /></div>
            <h3 style={{ fontSize: 20, fontWeight: 700, color: '#374151', margin: '0 0 8px' }}>No events yet</h3>
            <p style={{ fontSize: 14, color: '#9ca3af', margin: '0 0 24px' }}>Create events or upload a CSV to get started.</p>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
              <button onClick={() => openCreate()} style={{ padding: '12px 24px', borderRadius: 10, fontSize: 14, fontWeight: 600, border: 'none', background: 'linear-gradient(135deg, #7c3aed, #a855f7)', color: '#fff', cursor: 'pointer' }}>New Event</button>
              <button onClick={() => setShowUpload(true)} style={{ padding: '12px 24px', borderRadius: 10, fontSize: 14, fontWeight: 600, border: 'none', background: 'linear-gradient(135deg, #2563eb, #3b82f6)', color: '#fff', cursor: 'pointer' }}>Upload CSV</button>
            </div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {filteredEvents.map(evt => {
              const info = getTypeInfo(evt.event_type);
              const isPast = new Date(evt.start_datetime) < new Date();
              return (
                <div key={evt.id} style={{
                  background: '#fff', borderRadius: 16, border: '1px solid #e5e7eb', padding: '18px 22px',
                  opacity: isPast ? 0.55 : 1, transition: 'box-shadow 0.15s',
                }}
                onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.05)'}
                onMouseLeave={(e) => e.currentTarget.style.boxShadow = 'none'}
                >
                  <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 16 }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 6 }}>
                        <h3 style={{ fontSize: 15, fontWeight: 700, color: '#111827', margin: 0 }}>{evt.title}</h3>
                        <span style={{ padding: '2px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600, background: info.bg, color: info.color }}>{info.label}</span>
                        {evt.frequency && evt.frequency !== 'none' && (
                          <span style={{ padding: '2px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600, background: '#eef2ff', color: '#4f46e5', display: 'flex', alignItems: 'center', gap: 3 }}>
                            <Svg type="repeat" size={9} /> {evt.frequency}
                          </span>
                        )}
                        {evt.dj_announce && (
                          <span style={{ padding: '2px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600, background: '#fff7ed', color: '#c2410c', display: 'flex', alignItems: 'center', gap: 3 }}>
                            <Svg type="mic" size={9} /> DJ Announce
                          </span>
                        )}
                        {evt.play_song && (
                          <span style={{ padding: '2px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600, background: '#fdf2f8', color: '#be185d', display: 'flex', alignItems: 'center', gap: 3 }}>
                            <Svg type="music" size={9} /> Song
                          </span>
                        )}
                      </div>
                      {evt.description && <p style={{ fontSize: 13, color: '#6b7280', margin: '0 0 6px' }}>{evt.description}</p>}
                      <div style={{ display: 'flex', alignItems: 'center', gap: 14, fontSize: 11, color: '#9ca3af', flexWrap: 'wrap' }}>
                        <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}><Svg type="calendar" size={10} /> {formatDate(evt.start_datetime)}</span>
                        {!evt.all_day && <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}><Svg type="clock" size={10} /> {formatTime(evt.start_datetime)}</span>}
                        {evt.all_day && <span>All day</span>}
                        {evt.person_name && <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}><Svg type="user" size={10} /> {evt.person_name}{evt.person_role ? ` (${evt.person_role})` : ''}</span>}
                        {evt.song_request && <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}><Svg type="music" size={10} /> {evt.song_request}</span>}
                      </div>
                      {evt.dj_announcement_text && (
                        <div style={{ marginTop: 8, padding: '8px 12px', background: '#fffbeb', borderRadius: 8, border: '1px solid #fde68a', fontSize: 12, color: '#92400e', fontStyle: 'italic' }}>
                          "{evt.dj_announcement_text}"
                        </div>
                      )}
                    </div>
                    <div style={{ display: 'flex', gap: 4, flexShrink: 0 }}>
                      <button onClick={() => openEdit(evt)} style={{ padding: 7, borderRadius: 8, border: 'none', cursor: 'pointer', background: 'transparent', color: '#9ca3af' }}
                        onMouseEnter={(e) => e.currentTarget.style.color = '#7c3aed'} onMouseLeave={(e) => e.currentTarget.style.color = '#9ca3af'}
                      ><Svg type="edit" size={14} /></button>
                      <button onClick={() => handleDelete(evt.id, evt.title)} style={{ padding: 7, borderRadius: 8, border: 'none', cursor: 'pointer', background: 'transparent', color: '#d1d5db' }}
                        onMouseEnter={(e) => e.currentTarget.style.color = '#ef4444'} onMouseLeave={(e) => e.currentTarget.style.color = '#d1d5db'}
                      ><Svg type="trash" size={14} /></button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )
      )}

      {/* EVENT MODAL */}
      {showModal && modalWrap(
        <>
          <h2 style={{ fontSize: 22, fontWeight: 700, color: '#111827', margin: '0 0 24px' }}>{editing ? 'Edit Event' : 'New Event'}</h2>
          <form onSubmit={handleSave}>
            <div style={{ marginBottom: 18 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 8 }}>Event Type</label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                {EVENT_TYPES.map(t => pillBtn(formData.event_type === t.value, t, () => setFormData({ ...formData, event_type: t.value })))}
              </div>
            </div>
            <div style={{ marginBottom: 18 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Title *</label>
              <input type="text" required value={formData.title} onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                placeholder={isPersonEvent(formData.event_type) ? 'e.g. John Smith Birthday' : 'Event title'} style={inputStyle} onFocus={focusIn} onBlur={focusOut} />
            </div>
            {isPersonEvent(formData.event_type) && (
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 18 }}>
                <div>
                  <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Person Name</label>
                  <input type="text" value={formData.person_name} onChange={(e) => setFormData({ ...formData, person_name: e.target.value })}
                    placeholder="John Smith" style={inputStyle} onFocus={focusIn} onBlur={focusOut} />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Role</label>
                  <input type="text" value={formData.person_role} onChange={(e) => setFormData({ ...formData, person_role: e.target.value })}
                    placeholder="employee, manager" style={inputStyle} onFocus={focusIn} onBlur={focusOut} />
                </div>
              </div>
            )}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 18 }}>
              <div>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Start *</label>
                <input type="datetime-local" required value={formData.start_datetime} onChange={(e) => setFormData({ ...formData, start_datetime: e.target.value })} style={inputStyle} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>End</label>
                <input type="datetime-local" value={formData.end_datetime} onChange={(e) => setFormData({ ...formData, end_datetime: e.target.value })} style={inputStyle} />
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 14, marginBottom: 18 }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13, color: '#374151' }}>
                <input type="checkbox" checked={formData.all_day} onChange={(e) => setFormData({ ...formData, all_day: e.target.checked })}
                  style={{ width: 16, height: 16, accentColor: '#7c3aed' }} /> All day
              </label>
              <select value={formData.frequency} onChange={(e) => setFormData({ ...formData, frequency: e.target.value })} style={{ ...inputStyle, background: '#fff' }}>
                {FREQUENCIES.map(f => <option key={f.value} value={f.value}>{f.label}</option>)}
              </select>
              <select value={formData.priority} onChange={(e) => setFormData({ ...formData, priority: e.target.value })} style={{ ...inputStyle, background: '#fff' }}>
                {PRIORITIES.map(p => <option key={p.value} value={p.value}>{p.label}</option>)}
              </select>
            </div>
            <div style={{ marginBottom: 18 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Description</label>
              <textarea rows={2} value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                placeholder="Optional details..." style={{ ...inputStyle, resize: 'vertical' }} onFocus={focusIn} onBlur={focusOut} />
            </div>
            {isDJEvent(formData.event_type) && (
              <div style={{ background: '#fffbeb', borderRadius: 12, padding: 18, border: '1px solid #fde68a', marginBottom: 18 }}>
                <p style={{ fontSize: 13, fontWeight: 700, color: '#92400e', margin: '0 0 12px', display: 'flex', alignItems: 'center', gap: 6 }}><Svg type="mic" size={14} /> Broadcast Actions</p>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13, color: '#374151', marginBottom: 10 }}>
                  <input type="checkbox" checked={formData.dj_announce} onChange={(e) => setFormData({ ...formData, dj_announce: e.target.checked })}
                    style={{ width: 16, height: 16, accentColor: '#d97706' }} /> DJ announces this event on air
                </label>
                {formData.dj_announce && (
                  <textarea rows={2} value={formData.dj_announcement_text} onChange={(e) => setFormData({ ...formData, dj_announcement_text: e.target.value })}
                    placeholder={formData.event_type === 'birthday' ? `"Happy Birthday to ${formData.person_name || 'our team member'}!"` : 'What should the DJ say?'}
                    style={{ ...inputStyle, borderColor: '#fde68a', marginBottom: 10 }} />
                )}
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13, color: '#374151', marginBottom: 10 }}>
                  <input type="checkbox" checked={formData.play_song} onChange={(e) => setFormData({ ...formData, play_song: e.target.checked })}
                    style={{ width: 16, height: 16, accentColor: '#ec4899' }} /> Play a special song
                </label>
                {formData.play_song && (
                  <input type="text" value={formData.song_request} onChange={(e) => setFormData({ ...formData, song_request: e.target.value })}
                    placeholder="Song title - Artist" style={{ ...inputStyle, borderColor: '#fbcfe8', marginBottom: 10 }} />
                )}
                <div>
                  <label style={{ display: 'block', fontSize: 11, color: '#6b7280', marginBottom: 4 }}>Special Playlist</label>
                  <input type="text" value={formData.special_playlist} onChange={(e) => setFormData({ ...formData, special_playlist: e.target.value })}
                    placeholder="e.g. birthday, patriotic, jazz" style={inputStyle} onFocus={focusIn} onBlur={focusOut} />
                </div>
              </div>
            )}
            <div style={{ display: 'flex', gap: 12, borderTop: '1px solid #f3f4f6', paddingTop: 20 }}>
              <button type="button" onClick={closeModal} style={{
                flex: 1, padding: '12px 20px', borderRadius: 10, border: '1.5px solid #e5e7eb',
                background: '#fff', color: '#374151', fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: "'Outfit', sans-serif",
              }}>Cancel</button>
              <button type="submit" disabled={saving} style={{
                flex: 1, padding: '12px 20px', borderRadius: 10, border: 'none',
                background: saving ? '#c4b5fd' : 'linear-gradient(135deg, #7c3aed, #a855f7)',
                color: '#fff', fontSize: 14, fontWeight: 600, cursor: saving ? 'not-allowed' : 'pointer',
                fontFamily: "'Outfit', sans-serif", boxShadow: '0 4px 12px rgba(124,58,237,0.3)',
              }}>{saving ? 'Saving...' : (editing ? 'Save Changes' : 'Create Event')}</button>
            </div>
          </form>
        </>
      )}

      {/* UPLOAD MODAL */}
      {showUpload && modalWrap(
        <>
          <h2 style={{ fontSize: 22, fontWeight: 700, color: '#111827', margin: '0 0 24px', display: 'flex', alignItems: 'center', gap: 8 }}>
            <Svg type="upload" size={20} /> Upload Calendar Events
          </h2>
          <div style={{ background: '#eff6ff', borderRadius: 12, padding: 16, border: '1px solid #bfdbfe', marginBottom: 20 }}>
            <p style={{ fontSize: 13, fontWeight: 700, color: '#1e40af', margin: '0 0 8px' }}>Download CSV Templates</p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
              {['birthday', 'anniversary', 'promotion', 'holiday', 'mixed'].map(t => (
                <button key={t} onClick={() => downloadTemplate(t)} style={{
                  display: 'flex', alignItems: 'center', gap: 4, padding: '6px 12px', borderRadius: 8,
                  background: '#dbeafe', color: '#1d4ed8', fontSize: 11, fontWeight: 600,
                  border: '1px solid #93c5fd', cursor: 'pointer',
                }}><Svg type="download" size={10} /> {t.charAt(0).toUpperCase() + t.slice(1)}</button>
              ))}
            </div>
          </div>
          <div style={{ marginBottom: 18 }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 8 }}>Select CSV File</label>
            <input type="file" accept=".csv" onChange={handleFileUpload}
              style={{ ...inputStyle, padding: '10px 14px', fontSize: 13 }} />
          </div>
          {uploadData && (
            <div style={{ marginBottom: 18 }}>
              <p style={{ fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 8 }}>Preview: {uploadData.length} events found</p>
              <div style={{ maxHeight: 180, overflowY: 'auto', border: '1px solid #e5e7eb', borderRadius: 10 }}>
                <table style={{ width: '100%', fontSize: 12, borderCollapse: 'collapse' }}>
                  <thead><tr style={{ background: '#f9fafb', position: 'sticky', top: 0 }}>
                    <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600 }}>#</th>
                    <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600 }}>Title</th>
                    <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600 }}>Type</th>
                    <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600 }}>Date</th>
                  </tr></thead>
                  <tbody>{uploadData.map((row, i) => (
                    <tr key={i} style={{ borderTop: '1px solid #f3f4f6' }}>
                      <td style={{ padding: '6px 12px', color: '#9ca3af' }}>{i + 1}</td>
                      <td style={{ padding: '6px 12px', fontWeight: 600 }}>{row.title}</td>
                      <td style={{ padding: '6px 12px' }}>{getTypeInfo(row.event_type).label}</td>
                      <td style={{ padding: '6px 12px' }}>{row.start_datetime?.split('T')[0]}</td>
                    </tr>
                  ))}</tbody>
                </table>
              </div>
            </div>
          )}
          {uploadResults && (
            <div style={{ marginBottom: 18, padding: '12px 16px', borderRadius: 10, fontSize: 13,
              background: uploadResults.errors?.length ? '#fffbeb' : '#ecfdf5',
              border: uploadResults.errors?.length ? '1px solid #fde68a' : '1px solid #bbf7d0',
              color: uploadResults.errors?.length ? '#92400e' : '#166534',
            }}>
              <p style={{ fontWeight: 700, margin: 0 }}>{uploadResults.created} events created</p>
              {uploadResults.errors?.length > 0 && (
                <div style={{ marginTop: 4 }}>
                  <p style={{ margin: '4px 0' }}>{uploadResults.errors.length} errors:</p>
                  {uploadResults.errors.slice(0, 5).map((err, i) => <p key={i} style={{ fontSize: 11, margin: '2px 0' }}>Row {err.row}: {err.error}</p>)}
                </div>
              )}
            </div>
          )}
          <div style={{ display: 'flex', gap: 12, borderTop: '1px solid #f3f4f6', paddingTop: 20 }}>
            <button onClick={() => { setShowUpload(false); setUploadData(null); setUploadResults(null); }} style={{
              flex: 1, padding: '12px 20px', borderRadius: 10, border: '1.5px solid #e5e7eb',
              background: '#fff', color: '#374151', fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: "'Outfit', sans-serif",
            }}>{uploadResults ? 'Done' : 'Cancel'}</button>
            {uploadData && !uploadResults && (
              <button onClick={handleBulkUpload} disabled={uploading} style={{
                flex: 1, padding: '12px 20px', borderRadius: 10, border: 'none',
                background: uploading ? '#86efac' : 'linear-gradient(135deg, #059669, #10b981)',
                color: '#fff', fontSize: 14, fontWeight: 600, cursor: uploading ? 'not-allowed' : 'pointer',
                fontFamily: "'Outfit', sans-serif", boxShadow: '0 4px 12px rgba(5,150,105,0.3)',
              }}>{uploading ? 'Uploading...' : `Upload ${uploadData.length} Events`}</button>
            )}
          </div>
        </>
      )}
    </div>
  );
}